import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promotions-sanction-form',
  templateUrl: './promotions-sanction-form.component.html',
  styleUrls: ['./promotions-sanction-form.component.css']
})
export class PromotionsSanctionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Promotions/promotions-sanction/promotions-sanction-form/promotions-sanction-form.component.ts